<template>
  <div class="todo-map-coupon" v-loading="loading">
    <el-row>
      <el-form :inline="true" :model="filterForm" class="demo-form-inline">
        <el-form-item label="User Type">
          <el-select v-model="filterForm.userType" placeholder="Select User Type" @change="changeUserType($event)">
            <el-option
            v-for="item in userTypeOptions"
            :key="item.id"
            :label="item.typeDescription"
            :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Promo Code">
          <el-select v-model="filterForm.couponId" placeholder="Select Promo Code">
            <el-option
            v-for="item in promoCodeList"
            :key="item.id"
            :label="item.couponCode"
            :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Notification Already Sent">
          <el-checkbox v-model="filterForm.notificationAlreadySent"></el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="onFilterSubmit">Apply</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row type="flex" class="todo-provider">
        <el-col>
          <template align="right">
            <div align="right">
            <el-input class="searchBox"
            v-model="tableSearch"
            placeholder="Type to search"/>
            </div>
          </template>

          <el-table :data="getUsers.filter(data => !tableSearch || (data.legalName && data.legalName.toLowerCase().includes(tableSearch.toLowerCase())) || (data.email && data.email.toLowerCase().includes(tableSearch.toLowerCase())))"
            style="width: 100%" height="400" v-loading="loading" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              label="User Name"
              prop="name">
                <template slot-scope="scope">
                {{ scope.row.legalName }}
                </template>
            </el-table-column>
            <el-table-column
              label="Email"
              prop="title">
              <template slot-scope="scope">
                {{ scope.row.email }}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
    </el-row>
    <el-row>
      <el-col>
      <el-button type="primary" size="mini" @click="onMapCouponSubmit">Send Notification</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getCouponUsers, getUserTypes, getCouponByUserType, mapCoupons } from '@/api/vouchers'

  export default {
    props: {
      user: Object,
      loadCouponData: Object
    },
    watch: {
      loadCouponData: function(newVal, oldVal) {
        if (this.loadCouponData.couponId) {
          this.filterForm.userType = this.loadCouponData.userTypeVal
          this.changeUserTypeFunc()
          this.filterForm.couponId = this.loadCouponData.couponId
          this.viewUsersFunc()
        } else {
          this.filterForm.userType = ''
          this.filterForm.couponId = ''
          this.getUsers = []
          this.promoCodeList = []
        }
      }
    },
    data() {
      return {
        getUsers: [],
        userTypeOptions: [],
        promoCodeList: [],
        couponStatus: '',
        tableSearch: '',
        loading: true,
        selectedUsers: [],
        filterForm: {
          userType: '',
          couponId: '',
          notificationAlreadySent: ''
        },
        checked: []
      }
    },
    created: function() {
      this.getUserTypesFunc()
    },
    methods: {
      async viewUsersFunc() {
        this.loading = true
        const notificationStatus = (this.filterForm.notificationAlreadySent === true) ? this.filterForm.notificationAlreadySent : ''
        try {
          const { data } = await getCouponUsers(notificationStatus, this.filterForm.couponId)
          this.getUsers = data
        } catch (err) {
        }
        this.loading = false
      },
      changeUserType(event) {
        this.changeUserTypeFunc(event)
      },
      async changeUserTypeFunc() {
        this.promoCodeList = []
        this.filterForm.couponId = ''
        this.loading = true
        try {
          const { data } = await getCouponByUserType(this.filterForm.userType)
          this.promoCodeList = data
        } catch (err) {
        }
        if (this.loadCouponData.couponId) {
          this.filterForm.couponId = this.loadCouponData.couponId
        }
        this.loading = false
      },
      async getUserTypesFunc() {
        try {
          const { data } = await getUserTypes()
          this.userTypeOptions = data
        } catch (err) {
        }
        this.loading = false
      },
      onFilterSubmit() {
        this.viewUsersFunc()
      },
      onMapCouponSubmit() {
        const dataArr = {
          couponId: this.filterForm.couponId,
          userIds: JSON.parse(JSON.stringify(this.selectedUsers))
        }
        this.mapCouponsFunc(dataArr)
      },
      handleSelectionChange(val) {
        this.selectedUsers = []
        val.forEach((r, i) => {
          this.selectedUsers.push(r.userId)
        })
      },
      async mapCouponsFunc(dataArr) {
        this.loading = false
        try {
          const { data } = await mapCoupons(dataArr)
          // this.userTypeOptions = data
           this.filterForm.userType = ''
           this.filterForm.couponId = ''
           this.getUsers = []
           this.promoCodeList = []
          // this.viewUsersFunc()
        } catch (err) {
        }
        this.loading = false
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/variables';

  .el-button{
    margin:2px!important;width:auto!important
  }

  tr.el-table__row:hover{
    background-color:rgb(238, 237, 230)!important
  }
</style>
